import { useLayoutEffect, useRef } from "react";
import { UNIT_RATIOS, UnitType } from "../PatternStudio";

export const Ruler = ({ type, scale, offset, length, unit }: { type: 'h' | 'v', scale: number, offset: number, length: number, unit: UnitType }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useLayoutEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const dpr = window.devicePixelRatio || 1;
    const w = type === 'h' ? length : 30;
    const h = type === 'h' ? 30 : length;

    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width = `${w}px`;
    canvas.style.height = `${h}px`;
    ctx.scale(dpr, dpr);

    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#f9f9f9';
    ctx.fillRect(0, 0, w, h);

    ctx.beginPath();
    ctx.strokeStyle = '#ccc';
    ctx.lineWidth = 1;
    ctx.font = '10px sans-serif';
    ctx.fillStyle = '#666';

    const pxPerUnit = UNIT_RATIOS[unit];
    let tickStepUnit = 1;
    if (unit === 'px') tickStepUnit = 50;

    const tickStepPx = tickStepUnit * pxPerUnit;

    // Viewport range in pattern pixels
    const startPx = -offset / scale;
    const count = length / scale;

    const firstTickIndex = Math.floor(startPx / tickStepPx);
    const lastTickIndex = Math.ceil((startPx + count) / tickStepPx);

    for (let i = firstTickIndex; i <= lastTickIndex; i++) {
      const currentVal = i * tickStepUnit;
      const screenPos = (i * tickStepPx) * scale + offset;

      if (screenPos < -50 || screenPos > length + 50) continue;

      const labelValue = Math.round(currentVal * 10) / 10;

      if (type === 'h') {
        ctx.moveTo(screenPos, 20);
        ctx.lineTo(screenPos, 30);
        ctx.fillText(labelValue.toString(), screenPos + 4, 15);
      } else {
        ctx.moveTo(20, screenPos);
        ctx.lineTo(30, screenPos);
        ctx.save();
        ctx.translate(15, screenPos + 4);
        ctx.rotate(-Math.PI / 2);
        ctx.fillText(labelValue.toString(), 0, 0);
        ctx.restore();
      }
    }
    ctx.stroke();

  }, [scale, offset, length, type, unit]);

  return <canvas ref={canvasRef} />;
};
